var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer-list',[_c('router-link',{attrs:{"to":{ name: 'logs' }}},[_c('drawer-list-item',[_vm._v("My Logs")])],1),_vm._v(" "),_c('drawer-list-item',{on:{"click":_vm.openNewLog}},[_vm._v("New Log")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }